import type { ItemPhoto } from "@egalregal/shared";
import { requests } from "../../shared/api";
import { PhotoLightbox } from "../gallery/PhotoLightbox";

/** Full-screen photo lightbox for an item's photos (parity with the container
 *  media lightbox): prev/next, zoom and swipe across all of the item's photos. */
export function ItemPhotoLightbox({
  open,
  index,
  itemId,
  photos,
  onClose,
  onIndexChange,
}: {
  open: boolean;
  index: number | null;
  itemId: string;
  photos: ItemPhoto[];
  onClose: () => void;
  onIndexChange: (index: number) => void;
}) {
  const entries = photos.map((photo) => ({
    id: photo.id,
    name: photo.type,
    src: requests.media.itemPhotoUrl(itemId, photo.id),
  }));
  return (
    <PhotoLightbox
      open={open}
      photos={entries}
      index={index ?? 0}
      onClose={onClose}
      onIndexChange={onIndexChange}
      testId="item-photo-lightbox"
    />
  );
}